<template>
  <div
    class="order-rate mt12 justify-content-left"
    v-if="!order?.overallRating"
  >
    <img
      v-if="this.notRatedImage"
      :src="this.notRatedImage"
      class="no-rated-image mr12"
    />
    <div class="order-not-rated">
      <div class="order-rate-label" v-html="ratinglabel"></div>
      <star-rating
        :selectedRating="order.overallRating"
        :align="'left'"
        :tooltip="false"
        @starClick="starClick"
        :cancelBubble="true"
      ></star-rating>
    </div>
  </div>
  <div
    class="order-rate mt12 justify-content-between"
    v-else-if="order.overallRating"
  >
    <div class="order-rated">
      <div class="order-rate-label pb5">{{ ratedlabel }}</div>
      <star-rating
        :selectedRating="order.overallRating"
        :emptyGrey="true"
        :align="'left'"
        :tooltip="false"
        :isOrderHistoryPage="true"
        :ratingTag="ratingTags[order.overallRating]"
      ></star-rating>
    </div>
    <div class="sub-star" v-if="getSubratedString">
      <div class="order-rate-label pb5">
        {{ getSubratedString }}
      </div>
      <star-rating :align="'left'" :tooltip="false"></star-rating>
    </div>
  </div>
</template>

<script>
import {
  ORDER_TYPE,
  OrderHistoryRatingLabels,
} from "../helpers/OrderStatusConstants";
import Utility from "../helpers/utility";
import StarRating from "./feedback/StarRating.vue";
export default {
  name: "OrderHistoryRating",
  components: {
    StarRating,
  },
  props: ["dataOrder", "dataProps"],
  data() {
    return {
      order: {},
      ratingTags: {},
      moduleProps: {},
      notRatedImage: "",
    };
  },
  mounted() {
    this.order = this.dataOrder;
    this.moduleProps = this.dataProps;
    this.notRatedImage = this.moduleProps?.notRatedImage;
    this.ratingTags = JSON.parse(window?._siteProps_?.props?.ratingTags);
  },
  methods: {
    starClick(star, event) {
      event.cancelBubble = true;
      event.preventDefault();
      Utility.sendToCSATScreen(this.order?.id, star);
    },
  },
  computed: {
    getSubratedString() {
      if (!this.order.foodRatingProvided) {
        return (
          this.dataProps.orderFoodRatingLabel ||
          OrderHistoryRatingLabels.ORDER_FOOD_RATING_LABEL
        );
      } else if (
        !this.order.deliveryRatingProvided &&
        this.order.deliveryOrderType.deliveryTypeCode == ORDER_TYPE.DELIVERY
      ) {
        return (
          this.dataProps.orderDeliveryRatingLabel ||
          OrderHistoryRatingLabels.ORDER_DELIVERY_RATING_LABEL
        );
      } else if (
        !this.order.deliveryRatingProvided &&
        this.order.deliveryOrderType.deliveryTypeCode !== ORDER_TYPE.DELIVERY
      ) {
        return (
          this.dataProps.orderTakeawayRatingLabel ||
          OrderHistoryRatingLabels.ORDER_TAKEAWAY_RATING_LABEL
        );
      } else return "";
    },
    ratinglabel() {
      return (
        this.dataProps.orderRatingLabel ||
        OrderHistoryRatingLabels.ORDER_RATING_LABEL
      );
    },
    ratedlabel() {
      return (
        this.dataProps.orderRatedLabel ||
        OrderHistoryRatingLabels.ORDER_RATED_LABEL
      );
    },
  },
};
</script>
